import { useAppSelector } from '../../../Hooks/useAppSelector'
import { LabsSelectors } from '../StoreAdapter'

export const useLabSelector = (labId: string) => {
  return useAppSelector((state) => LabsSelectors.selectById(state, labId))
}
